const HOME_DOMAIN = process.env.HOME_DOMAIN;
const TUTOR_DOMAIN = process.env.TUTOR_DOMAIN;
const DOCS_DOMAIN = process.env.DOCS_DOMAIN;

function getHomePath() {
    return `${window.location.protocol}//${HOME_DOMAIN}`;
}
export function getTutorPath() {
    return `${window.location.protocol}//${TUTOR_DOMAIN}`;
}

const menuItems = {
    home: {
        title: 'Platform',
        href: `${getHomePath()}/`,
        path: ''
    },
    solution: {
        title: 'Public Safety',
        href: `${getHomePath()}/alan-safety`,
        path: 'alan-safety'
    },
    operations: {
        title: 'Retail Operations',
        href: `${getHomePath()}/retail-operations`,
        path: 'retail-operations'
    },
    maintenance: {
        title: 'Field Maintenance',
        href: `${getHomePath()}/field-maintenance`,
        path: 'field-maintenance'
    },
    platform: {
        title: 'Platform',
        href: `${getHomePath()}/platform`,
        path: 'platform'
    },
    aboutUs: {
        title: 'About Us',
        href: `${getHomePath()}/about-us`,
        path: 'about-us'
    },
    securityByDesign: {
        title: 'Security By Design',
        href: `${getHomePath()}/security-by-design`,
        path: 'security-by-design'
    },
    privacyPolicy: {
        title: 'Privacy Policy',
        href: `${getHomePath()}/privacy-policy`,
        path: 'privacy-policy'
    },
    termsOfService: {
        title: 'Terms of Service',
        href: `${getHomePath()}/terms-of-service`,
        path: 'terms-of-service'
    },
    blog: {
        title: 'Blog',
        href: `${getHomePath()}/blog`,
        path: 'blog'
    },
    careers: {
        title: 'Careers',
        href: `${getHomePath()}/careers`,
        path: 'careers'
    },
    docs: {
        title: 'Docs',
        href: `${getHomePath()}/docs`,
        path: 'docs'
    },
    releases: {
        title: 'Releases',
        href: `${getHomePath()}/releases`,
        path: 'releases'
    },
    ionic: {
        title: 'Ionic',
        href: `${getHomePath()}/ionic`,
        path: 'ionic'
    },
    sap: {
        title: 'SAP',
        href: `${getHomePath()}/sap`,
        path: 'sap'
    },
    flutter: {
        title: 'Flutter',
        href: `${getHomePath()}/flutter`,
        path: 'flutter'
    },
    signIn: {
        title: 'Sign In',
        href: `${getTutorPath()}/login`,
        path: 'login'
    },
    signUp: {
        title: 'Sign Up',
        href: `${getTutorPath()}/register`,
        path: 'register'
    },
    pricing: {
        title: 'Pricing',
        href: `${getHomePath()}/pricing`,
        path: 'pricing'
    },
    whyAlan: {
        title: 'Why Alan',
        href: `${getHomePath()}/why-alan`,
        path: 'why-alan'
    },
    branding: {
        title: 'Brand Assets',
        href: `${getHomePath()}/brand-assets`,
        path: 'brand-assets'
    },
    integrations: {
        title: 'Integrations',
        href: `${getHomePath()}/integrations`,
        path: 'integrations'
    },
    developers: {
        title: 'Platform',
        href: `${getHomePath()}/developers`,
        path: 'developers'
    },
    company: {
        title: 'Company',
        href: `${getHomePath()}/company`,
        path: 'company'
    },
    webinar: {
        title: 'Webinar',
        href: `${getHomePath()}/webinar`,
        path: 'webinar'
    },
    browserPlugin: {
        title: 'Browser Plugin',
        href: `${getHomePath()}/browser-plugin`,
        path: '/browser-plugin'
    },
};

export default menuItems;